import { Editor } from 'slate';
import Tool, { type ToolArgsWithController } from '../../../tools/Tool';
import { COPYABLE_MARKS, COPY_FORMAT_STORAGE_KEY } from './formatCopying';
import { svgToIcon } from '../../../components/Toolbar/toolbarUtils';
import copyFormatSvg from '../../../assets/icons/copyFormat.svg';

// Tool to copy the current format (marks) from the selected text.
class ToolCopyFormat extends Tool {
  static toolName = 'Copy format';
  static shortcut = 'Cmd+Option+c';
  static ariaLabel = 'Copy format from selection';

  static action({ editor }: ToolArgsWithController): void {
    if (!editor?.selection) return;

    // Get the current marks from the selection
    const marks = Editor.marks(editor);

    if (!marks) {
      // If no marks, store an empty format object
      const emptyFormat = { marks: {} };
      localStorage.setItem(
        COPY_FORMAT_STORAGE_KEY,
        JSON.stringify(emptyFormat)
      );
      return;
    }

    const formatMarks: Record<string, string | boolean> = {};

    // Copy marks
    for (const mark of COPYABLE_MARKS) {
      if (marks[mark] !== undefined) {
        formatMarks[mark] = marks[mark];
      }
    }

    // Store the format in localStorage as JSON
    const copiedFormat = { marks: formatMarks };
    localStorage.setItem(COPY_FORMAT_STORAGE_KEY, JSON.stringify(copiedFormat));
  }

  static isEnabled({ editor }: ToolArgsWithController): boolean {
    return !!editor?.selection;
  }

  static renderMenuIcon() {
    return svgToIcon(copyFormatSvg);
  }
}

export default ToolCopyFormat;
